(function(){ window.BMap_loadScriptTime = (new Date).getTime(); document.write('<script type="text/javascript" src="http://api.map.baidu.com/getscript?v=2.0&ak=5b31afcdea6af2d7d3677ca5c1a22c46&services=&t=20160310104956"></script>');})();

export function MP() {  
    return new Promise(function (resolve, reject) {  
      window.onload = function () {  
        resolve(BMap)  
      }  
      var script = document.createElement("script");  
      script.type = "text/javascript";  
      script.src = "http://api.map.baidu.com/getscript?v=2.0&ak=5b31afcdea6af2d7d3677ca5c1a22c46&services=&t=20160310104956";  
      script.onerror = reject;  
      document.head.appendChild(script);  
    })  
  }  


// WEBPACK FOOTER //
// ./src/assets/Scripts/ditu.js